webpackJsonp([20],{

/***/ 2564:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _general = __webpack_require__(113);

var _login_controller = __webpack_require__(2565);

var _login_controller2 = _interopRequireDefault(_login_controller);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapStateToProps(state) {
    var config = (0, _general.getConfig)(state);
    var license = (0, _general.getLicense)(state);

    var customBrand = license.CustomBrand === 'true';
    var isLicensed = license.IsLicensed === 'true';

    var customBrandText = config.CustomBrandText;
    var customDescriptionText = config.CustomDescriptionText;
    var enableCustomBrand = config.EnableCustomBrand === 'true';
    var enableLdap = config.EnableLdap === 'true';
    var enableOpenServer = config.EnableOpenServer === 'true';
    var enableSaml = config.EnableSaml === 'true';
    var enableSignInWithEmail = config.EnableSignInWithEmail === 'true';
    var enableSignInWithUsername = config.EnableSignInWithUsername === 'true';
    var enableSignUpWithEmail = config.EnableSignUpWithEmail === 'true';
    var enableSignUpWithGitLab = config.EnableSignUpWithGitLab === 'true';
    var enableSignUpWithGoogle = config.EnableSignUpWithGoogle === 'true';
    var enableSignUpWithOffice365 = config.EnableSignUpWithOffice365 === 'true';
    var experimentalPrimaryTeam = config.ExperimentalPrimaryTeam;
    var ldapLoginFieldName = config.LdapLoginFieldName;
    var samlLoginButtonText = config.SamlLoginButtonText;
    var siteName = config.SiteName;

    return {
        customBrand: customBrand,
        isLicensed: isLicensed,
        customBrandText: customBrandText,
        customDescriptionText: customDescriptionText,
        enableCustomBrand: enableCustomBrand,
        enableLdap: enableLdap,
        enableOpenServer: enableOpenServer,
        enableSaml: enableSaml,
        enableSignInWithEmail: enableSignInWithEmail,
        enableSignInWithUsername: enableSignInWithUsername,
        enableSignUpWithEmail: enableSignUpWithEmail,
        enableSignUpWithGitLab: enableSignUpWithGitLab,
        enableSignUpWithGoogle: enableSignUpWithGoogle,
        enableSignUpWithOffice365: enableSignUpWithOffice365,
        experimentalPrimaryTeam: experimentalPrimaryTeam,
        ldapLoginFieldName: ldapLoginFieldName,
        samlLoginButtonText: samlLoginButtonText,
        siteName: siteName
    };
} // Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_login_controller2.default);

/***/ }),

/***/ 2565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(761);

var _reactRouterDom = __webpack_require__(269);

var _client = __webpack_require__(270);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _team_actions = __webpack_require__(832);

var _user_actions = __webpack_require__(781);

var _browser_store = __webpack_require__(825);

var _browser_store2 = _interopRequireDefault(_browser_store);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _team_store = __webpack_require__(779);

var _team_store2 = _interopRequireDefault(_team_store);

var _browser_history = __webpack_require__(273);

var _constants = __webpack_require__(29);

var _constants2 = _interopRequireDefault(_constants);

var _text_formatting = __webpack_require__(811);

var TextFormatting = _interopRequireWildcard(_text_formatting);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _post_utils = __webpack_require__(803);

var _logo = __webpack_require__(851);

var _logo2 = _interopRequireDefault(_logo);

var _site_name_and_description = __webpack_require__(941);

var _site_name_and_description2 = _interopRequireDefault(_site_name_and_description);

var _announcement_bar = __webpack_require__(882);

var _announcement_bar2 = _interopRequireDefault(_announcement_bar);

var _form_error = __webpack_require__(822);

var _form_error2 = _interopRequireDefault(_form_error);

var _login_mfa = __webpack_require__(994);

var _login_mfa2 = _interopRequireDefault(_login_mfa);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginController = function (_React$Component) {
    (0, _inherits3.default)(LoginController, _React$Component);
    (0, _createClass3.default)(LoginController, null, [{
        key: 'propTypes',
        get: function get() {
            return {
                location: _propTypes2.default.object.isRequired,

                customBrand: _propTypes2.default.bool.isRequired,
                isLicensed: _propTypes2.default.bool.isRequired,

                customBrandText: _propTypes2.default.string,
                customDescriptionText: _propTypes2.default.string,
                enableCustomBrand: _propTypes2.default.bool.isRequired,
                enableLdap: _propTypes2.default.bool.isRequired,
                enableOpenServer: _propTypes2.default.bool.isRequired,
                enableSaml: _propTypes2.default.bool.isRequired,
                enableSignInWithEmail: _propTypes2.default.bool.isRequired,
                enableSignInWithUsername: _propTypes2.default.bool.isRequired,
                enableSignUpWithEmail: _propTypes2.default.bool.isRequired,
                enableSignUpWithGitLab: _propTypes2.default.bool.isRequired,
                enableSignUpWithGoogle: _propTypes2.default.bool.isRequired,
                enableSignUpWithOffice365: _propTypes2.default.bool.isRequired,
                experimentalPrimaryTeam: _propTypes2.default.string,
                ldapLoginFieldName: _propTypes2.default.string,
                samlLoginButtonText: _propTypes2.default.string,
                siteName: _propTypes2.default.string
            };
        }
    }]);

    function LoginController(props) {
        (0, _classCallCheck3.default)(this, LoginController);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LoginController.__proto__ || (0, _getPrototypeOf2.default)(LoginController)).call(this, props));

        _this.preSubmit = _this.preSubmit.bind(_this);
        _this.submit = _this.submit.bind(_this);
        _this.finishSignin = _this.finishSignin.bind(_this);

        _this.handleLoginIdChange = _this.handleLoginIdChange.bind(_this);
        _this.handlePasswordChange = _this.handlePasswordChange.bind(_this);

        var loginId = '';
        if (new URLSearchParams(_this.props.location.search).get('extra') === _constants2.default.SIGNIN_VERIFIED && new URLSearchParams(_this.props.location.search).get('email')) {
            loginId = new URLSearchParams(_this.props.location.search).get('email');
        }

        _this.state = {
            ldapEnabled: _this.props.isLicensed && _this.props.enableLdap,
            usernameSigninEnabled: _this.props.enableSignInWithUsername,
            emailSigninEnabled: _this.props.enableSignInWithEmail,
            samlEnabled: _this.props.isLicensed && _this.props.enableSaml,
            loginId: loginId,
            password: '',
            showMfa: false,
            loading: false
        };
        return _this;
    }

    (0, _createClass3.default)(LoginController, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.title = this.props.siteName;
            _browser_store2.default.removeGlobalItem('team');
            if (_user_store2.default.getCurrentUser()) {
                GlobalActions.redirectUserToDefaultTeam();
            }

            if (new URLSearchParams(this.props.location.search).get('extra') === _constants2.default.SIGNIN_VERIFIED && new URLSearchParams(this.props.location.search).get('email')) {
                this.refs.password.focus();
            }
        }
    }, {
        key: 'preSubmit',
        value: function preSubmit(e) {
            var _this2 = this;

            e.preventDefault();

            var location = this.props.location;

            var newQuery = location.search.replace(/(extra=password_change)&?/i, '');
            if (newQuery !== location.search) {
                _browser_history.browserHistory.replace('' + location.pathname + newQuery + location.hash);
            }

            // password managers don't always call onInput handlers for form fields so it's possible
            // for the state to get out of sync with what the user sees in the browser
            var loginId = this.refs.loginId.value;
            if (loginId !== this.state.loginId) {
                this.setState({ loginId: loginId });
            }

            var password = this.refs.password.value;
            if (password !== this.state.password) {
                this.setState({ password: password });
            }

            // don't trim the password since we support spaces in passwords
            loginId = loginId.trim().toLowerCase();

            if (!loginId) {
                // it's slightly weird to be constructing the message ID, but it's a bit nicer than triply nested if statements
                var msgId = 'login.no';
                if (this.state.emailSigninEnabled) {
                    msgId += 'Email';
                }
                if (this.state.usernameSigninEnabled) {
                    msgId += 'Username';
                }
                if (this.state.ldapEnabled) {
                    msgId += 'LdapUsername';
                }

                this.setState({
                    serverError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: msgId,
                        values: {
                            ldapUsername: this.props.ldapLoginFieldName || Utils.localizeMessage('login.ldapUsernameLower', 'AD/LDAP username')
                        }
                    })
                });
                return;
            }

            if (!password) {
                this.setState({
                    serverError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'login.noPassword',
                        defaultMessage: 'Please enter your password'
                    })
                });
                return;
            }

            (0, _user_actions.checkMfa)(loginId, function (requiresMfa) {
                if (requiresMfa) {
                    _this2.setState({ showMfa: true });
                } else {
                    _this2.submit(loginId, password, '');
                }
            }, function (err) {
                _this2.setState({ serverError: err.message });
            });
        }
    }, {
        key: 'submit',
        value: function submit(loginId, password, token) {
            var _this3 = this;

            this.setState({ serverError: null, loading: true });

            (0, _user_actions.webLogin)(loginId, password, token, function () {
                // check for query params brought over from signup_user_complete
                var params = new URLSearchParams(_this3.props.location.search);
                var hash = params.get('h') || '';
                var data = params.get('d') || '';
                var inviteId = params.get('id') || '';

                if (inviteId || hash) {
                    (0, _team_actions.addUserToTeamFromInvite)(data, hash, inviteId, function (team) {
                        _this3.finishSignin(team);
                    }, function () {
                        // there's not really a good way to deal with this, so just let the user log in like normal
                        _this3.finishSignin();
                    });

                    return;
                }

                _this3.finishSignin();
            }, function (err) {
                if (err.id === 'api.user.login.not_verified.app_error') {
                    _browser_history.browserHistory.push('/should_verify_email?&email=' + encodeURIComponent(loginId));
                } else if (err.id === 'store.sql_user.get_for_login.app_error' || err.id === 'ent.ldap.do_login.user_not_registered.app_error') {
                    _this3.setState({
                        showMfa: false,
                        loading: false,
                        serverError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'login.userNotFound',
                            defaultMessage: 'We couldn\'t find an account matching your login credentials.'
                        })
                    });
                } else if (err.id === 'api.user.check_user_password.invalid.app_error' || err.id === 'ent.ldap.do_login.invalid_password.app_error') {
                    _this3.setState({
                        showMfa: false,
                        loading: false,
                        serverError: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'login.invalidPassword',
                            defaultMessage: 'Your password is incorrect.'
                        })
                    });
                } else {
                    _this3.setState({ showMfa: false, serverError: err.message, loading: false });
                }
            });
        }
    }, {
        key: 'finishSignin',
        value: function finishSignin(team) {
            var experimentalPrimaryTeam = this.props.experimentalPrimaryTeam;
            var primaryTeam = _team_store2.default.getByName(experimentalPrimaryTeam);
            var query = new URLSearchParams(this.props.location.search);
            var redirectTo = query.get('redirect_to');

            GlobalActions.loadCurrentLocale();
            if (redirectTo && redirectTo.match(/^\/([^/]|$)/)) {
                _browser_history.browserHistory.push(redirectTo);
            } else if (team) {
                _browser_history.browserHistory.push('/' + team.name);
            } else if (primaryTeam) {
                _browser_history.browserHistory.push('/' + primaryTeam.name + '/channels/' + _constants2.default.DEFAULT_CHANNEL);
            } else {
                GlobalActions.redirectUserToDefaultTeam();
            }
        }
    }, {
        key: 'handleLoginIdChange',
        value: function handleLoginIdChange(e) {
            this.setState({
                loginId: e.target.value
            });
        }
    }, {
        key: 'handlePasswordChange',
        value: function handlePasswordChange(e) {
            this.setState({
                password: e.target.value
            });
        }
    }, {
        key: 'createCustomLogin',
        value: function createCustomLogin() {
            if (this.props.isLicensed && this.props.customBrand && this.props.enableCustomBrand) {
                var text = this.props.customBrandText || '';
                var formattedText = TextFormatting.formatText(text);

                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('img', {
                        src: _client.Client4.getBrandImageUrl(0)
                    }),
                    _react2.default.createElement(
                        'div',
                        null,
                        (0, _post_utils.messageHtmlToComponent)(formattedText, false, { mentions: false })
                    )
                );
            }

            return null;
        }
    }, {
        key: 'createLoginPlaceholder',
        value: function createLoginPlaceholder() {
            var ldapEnabled = this.state.ldapEnabled;
            var usernameSigninEnabled = this.state.usernameSigninEnabled;
            var emailSigninEnabled = this.state.emailSigninEnabled;

            var loginPlaceholders = [];
            if (emailSigninEnabled) {
                loginPlaceholders.push(Utils.localizeMessage('login.email', 'Email'));
            }

            if (usernameSigninEnabled) {
                loginPlaceholders.push(Utils.localizeMessage('login.username', 'Username'));
            }

            if (ldapEnabled) {
                if (this.props.ldapLoginFieldName) {
                    loginPlaceholders.push(this.props.ldapLoginFieldName);
                } else {
                    loginPlaceholders.push(Utils.localizeMessage('login.ldapUsername', 'AD/LDAP Username'));
                }
            }

            if (loginPlaceholders.length >= 2) {
                return loginPlaceholders.slice(0, loginPlaceholders.length - 1).join(', ') + Utils.localizeMessage('login.placeholderOr', ' or ') + loginPlaceholders[loginPlaceholders.length - 1];
            } else if (loginPlaceholders.length === 1) {
                return loginPlaceholders[0];
            }

            return '';
        }
    }, {
        key: 'checkSignUpEnabled',
        value: function checkSignUpEnabled() {
            return this.props.enableSignUpWithEmail || this.props.enableSignUpWithGitLab || this.props.enableSignUpWithOffice365 || this.props.enableSignUpWithGoogle || this.props.enableLdap || this.props.enableSaml;
        }
    }, {
        key: 'createLoginOptions',
        value: function createLoginOptions() {
            var extraParam = new URLSearchParams(this.props.location.search).get('extra');
            var extraBox = '';
            if (extraParam) {
                if (extraParam === _constants2.default.SIGNIN_CHANGE) {
                    extraBox = _react2.default.createElement(
                        'div',
                        { className: 'alert alert-success' },
                        _react2.default.createElement('i', { className: 'fa fa-check' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'login.changed',
                            defaultMessage: ' Sign-in method changed successfully'
                        })
                    );
                } else if (extraParam === _constants2.default.SIGNIN_VERIFIED) {
                    extraBox = _react2.default.createElement(
                        'div',
                        { className: 'alert alert-success' },
                        _react2.default.createElement('i', { className: 'fa fa-check' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'login.verified',
                            defaultMessage: ' Email Verified'
                        })
                    );
                } else if (extraParam === _constants2.default.SESSION_EXPIRED) {
                    extraBox = _react2.default.createElement(
                        'div',
                        { className: 'alert alert-warning' },
                        _react2.default.createElement('i', { className: 'fa fa-exclamation-triangle' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'login.session_expired',
                            defaultMessage: ' Your session has expired. Please login again.'
                        })
                    );
                } else if (extraParam === _constants2.default.PASSWORD_CHANGE) {
                    extraBox = _react2.default.createElement(
                        'div',
                        { className: 'alert alert-success' },
                        _react2.default.createElement('i', { className: 'fa fa-check' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'login.passwordChanged',
                            defaultMessage: ' Password updated successfully'
                        })
                    );
                }
            }

            var loginControls = [];

            var ldapEnabled = this.state.ldapEnabled;
            var gitlabSigninEnabled = this.props.enableSignUpWithGitLab;
            var googleSigninEnabled = this.props.enableSignUpWithGoogle;
            var office365SigninEnabled = this.props.enableSignUpWithOffice365;
            var samlSigninEnabled = this.state.samlEnabled;
            var usernameSigninEnabled = this.state.usernameSigninEnabled;
            var emailSigninEnabled = this.state.emailSigninEnabled;

            if (emailSigninEnabled || usernameSigninEnabled || ldapEnabled) {
                var errorClass = '';
                if (this.state.serverError) {
                    errorClass = ' has-error';
                }

                var loginButton = _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'login.signIn',
                    defaultMessage: 'Sign in'
                });

                if (this.state.loading) {
                    loginButton = _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement('span', { className: 'fa fa-refresh icon--rotate' }),
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'login.signInLoading',
                            defaultMessage: 'Signing in...'
                        })
                    );
                }

                loginControls.push(_react2.default.createElement(
                    'form',
                    {
                        key: 'loginBoxes',
                        onSubmit: this.preSubmit
                    },
                    _react2.default.createElement(
                        'div',
                        { className: 'signup__email-container' },
                        _react2.default.createElement(_form_error2.default, {
                            error: this.state.serverError,
                            margin: true
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' + errorClass },
                            _react2.default.createElement('input', {
                                id: 'loginId',
                                className: 'form-control',
                                ref: 'loginId',
                                name: 'loginId',
                                value: this.state.loginId,
                                onChange: this.handleLoginIdChange,
                                placeholder: this.createLoginPlaceholder(),
                                spellCheck: 'false',
                                autoCapitalize: 'off',
                                autoFocus: 'true'
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' + errorClass },
                            _react2.default.createElement('input', {
                                id: 'loginPassword',
                                type: 'password',
                                className: 'form-control',
                                ref: 'password',
                                name: 'password',
                                value: this.state.password,
                                onChange: this.handlePasswordChange,
                                placeholder: Utils.localizeMessage('login.password', 'Password'),
                                spellCheck: 'false'
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'form-group' },
                            _react2.default.createElement(
                                'button',
                                {
                                    id: 'loginButton',
                                    type: 'submit',
                                    className: 'btn btn-primary'
                                },
                                loginButton
                            )
                        )
                    )
                ));
            }

            if (this.props.enableOpenServer && this.checkSignUpEnabled()) {
                loginControls.push(_react2.default.createElement(
                    'div',
                    {
                        className: 'form-group',
                        key: 'signup'
                    },
                    _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'login.noAccount',
                            defaultMessage: 'Don\'t have an account? '
                        }),
                        _react2.default.createElement(
                            _reactRouterDom.Link,
                            {
                                id: 'signup',
                                to: '/signup_user_complete' + this.props.location.search,
                                className: 'signup-team-login'
                            },
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'login.create',
                                defaultMessage: 'Create one now'
                            })
                        )
                    )
                ));
            }

            if (usernameSigninEnabled || emailSigninEnabled) {
                loginControls.push(_react2.default.createElement(
                    'div',
                    {
                        key: 'forgotPassword',
                        className: 'form-group'
                    },
                    _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: '/reset_password' },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'login.forgot',
                            defaultMessage: 'I forgot my password'
                        })
                    )
                ));
            }

            if ((emailSigninEnabled || usernameSigninEnabled || ldapEnabled) && (gitlabSigninEnabled || googleSigninEnabled || samlSigninEnabled || office365SigninEnabled)) {
                loginControls.push(_react2.default.createElement(
                    'div',
                    {
                        key: 'divider',
                        className: 'or__container'
                    },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'login.or',
                        defaultMessage: 'or'
                    })
                ));

                loginControls.push(_react2.default.createElement(
                    'h5',
                    { key: 'oauthHeader' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'login.signInWith',
                        defaultMessage: 'Sign in with:'
                    })
                ));
            }

            if (gitlabSigninEnabled) {
                loginControls.push(_react2.default.createElement(
                    'a',
                    {
                        className: 'btn btn-custom-login gitlab',
                        key: 'gitlab',
                        href: _client.Client4.getOAuthRoute() + '/gitlab/login' + this.props.location.search
                    },
                    _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement('span', { className: 'icon' }),
                        _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'login.gitlab',
                                defaultMessage: 'GitLab'
                            })
                        )
                    )
                ));
            }

            if (googleSigninEnabled) {
                loginControls.push(_react2.default.createElement(
                    'a',
                    {
                        className: 'btn btn-custom-login google',
                        key: 'google',
                        href: _client.Client4.getOAuthRoute() + '/google/login' + this.props.location.search
                    },
                    _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement('span', { className: 'icon' }),
                        _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'login.google',
                                defaultMessage: 'Google Apps'
                            })
                        )
                    )
                ));
            }

            if (office365SigninEnabled) {
                loginControls.push(_react2.default.createElement(
                    'a',
                    {
                        className: 'btn btn-custom-login office365',
                        key: 'office365',
                        href: _client.Client4.getOAuthRoute() + '/office365/login' + this.props.location.search
                    },
                    _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement('span', { className: 'icon' }),
                        _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'login.office365',
                                defaultMessage: 'Office 365'
                            })
                        )
                    )
                ));
            }

            if (samlSigninEnabled) {
                loginControls.push(_react2.default.createElement(
                    'a',
                    {
                        className: 'btn btn-custom-login saml',
                        key: 'saml',
                        href: '/login/sso/saml' + this.props.location.search
                    },
                    _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement('span', { className: 'icon fa fa-lock fa--margin-top' }),
                        _react2.default.createElement(
                            'span',
                            null,
                            this.props.samlLoginButtonText
                        )
                    )
                ));
            }

            if (loginControls.length === 0) {
                loginControls.push(_react2.default.createElement(_form_error2.default, {
                    error: _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'login.noMethods',
                        defaultMessage: 'No sign-in methods are enabled. Please contact your System Administrator.'
                    }),
                    margin: true
                }));
            }

            return _react2.default.createElement(
                'div',
                null,
                extraBox,
                loginControls
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                customDescriptionText = _props.customDescriptionText,
                isLicensed = _props.isLicensed,
                siteName = _props.siteName;


            var content = void 0;
            var customContent = void 0;
            var customClass = void 0;
            if (this.state.showMfa) {
                content = _react2.default.createElement(_login_mfa2.default, {
                    loginId: this.state.loginId,
                    password: this.state.password,
                    submit: this.submit
                });
            } else {
                content = this.createLoginOptions();
                customContent = this.createCustomLogin();
                if (customContent) {
                    customClass = 'branded';
                }
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_announcement_bar2.default, null),
                _react2.default.createElement(
                    'div',
                    { className: 'col-sm-12' },
                    _react2.default.createElement(
                        'div',
                        { className: 'signup-team__container ' + customClass },
                        _react2.default.createElement(
                            'div',
                            { className: 'signup__markdown' },
                            customContent
                        ),
                        _react2.default.createElement('img', {
                            className: 'signup-team-logo',
                            src: _logo2.default
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: 'signup__content' },
                            _react2.default.createElement(_site_name_and_description2.default, {
                                customDescriptionText: customDescriptionText,
                                isLicensed: isLicensed,
                                siteName: siteName
                            }),
                            content
                        )
                    )
                )
            );
        }
    }]);
    return LoginController;
}(_react2.default.Component); // Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

exports.default = LoginController;

/***/ })

});


// WEBPACK FOOTER //
// 20.8a143881c43f34451cb9.js